import { StyleSheet } from "react-native";
import { themeConstants } from "styles/theme";
import { ThemedValues } from "styles/themed";
import HelperPlatform from "utils/helper-platform";

export const layoutStyles = StyleSheet.create({
	cardNoPadding: {
		marginHorizontal: -24,
		marginVertical: -16,
	},
	
	containerCenter: {
		alignItems: "center",
		justifyContent: "center",
	},
	
	headerStyles: {
		justifyContent: 'center',
		alignItems: 'center',
		marginHorizontal: -16,
		paddingHorizontal: 16,
	},
	
	scrollViewPadding: {
		paddingVertical: ThemedValues.marginVertical,
		paddingHorizontal: ThemedValues.marginHorizontal,
		width: HelperPlatform.isNotWeb() ? 'auto' : 900 ,
		marginHorizontal: HelperPlatform.isNotWeb() ? 0 : 'auto'
	},
	
	bottomButtonContainer: {
		paddingHorizontal: ThemedValues.marginHorizontal,
		marginBottom: ThemedValues.marginHorizontal
	},
	
	flexOne: {
		flex: 1
	},
	flexNone: {
		flex: 0
	},
	flexUnset: {
		flex: HelperPlatform.select({
			web: 'unset',
			default: 0
		})
	}
});

export function themeIsLight( theme = themeConstants.LIGHT ) {
	return (theme === themeConstants.LIGHT );
}
